module.exports = __webpack_public_path__ + "static/media/search_active.20e0bc80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/search_active.svg
// module id = 1079
// module chunks = 36